module.exports = __webpack_public_path__ + "img/43_82.d68f5ac1.png";